// Mock data for Thybe Ampe Portfolio

export const portfolioProjects = [
  {
    id: 1,
    title: "YPHI - Your Personal Health Institute",
    category: "Fitness & Coaching",
    description: "Moderne health coaching platform met personal training, groepslessen en transformatieprogramma's in Gistel.",
    image: "/yphi-hero.png",
    url: "#"
  },
  {
    id: 2,
    title: "Glazenwasserij Otten",
    category: "Dienstverlening",
    description: "Professionele website voor ramenreinigingsbedrijf met 5.0 Google Score. Kristalheldere ruiten, professioneel gereinigd.",
    image: "/glazenwasser-hero.png",
    url: "#"
  },
  {
    id: 3,
    title: "Online Coach Sander",
    category: "Fitness & Coaching",
    description: "Personal training & online coaching platform. Transformeer je lichaam, versterk je mindset met resultaatgerichte begeleiding.",
    image: "/coach-sander.png",
    url: "#"
  },
  {
    id: 4,
    title: "May Rodrigues - Personal Coach",
    category: "Fitness & Coaching",
    description: "Strong Body. Confident Mind. Persoonlijke coaching in Laakdal voor vrouwen die echt resultaat willen met 5.0/5 Google Reviews.",
    image: "/may-rodrigues.png",
    url: "#"
  },
  {
    id: 5,
    title: "BodyLifestyle - Coaching Platform",
    category: "Fitness & Coaching",
    description: "Boost je lichaam. Boost je leven. Persoonlijke coaching in Aalst voor wie resultaat wil - geen excuses, alleen progressie.",
    image: "/bodylifestyle.png",
    url: "#"
  },
  {
    id: 6,
    title: "Beweegstudio Sixty 7",
    category: "Wellness & Beweging",
    description: "Meer bewegen. Beter leven. Professionele beweegbegeleiding voor 55-plussers in Brasschaat. Train veilig en op eigen tempo.",
    image: "/beweegstudio.png",
    url: "#"
  }
];

export const services = [
  {
    id: 1,
    title: "Website Ontwerp",
    description: "Professionele website op maat voor jouw bedrijf. Modern, gebruiksvriendelijk en volledig responsive.",
    features: [
      "Op maat gemaakt design",
      "Mobielvriendelijk",
      "Moderne uitstraling",
      "Snelle laadtijd"
    ]
  },
  {
    id: 2,
    title: "Website Ontwikkeling",
    description: "Technische ontwikkeling van snelle, veilige en schaalbare websites met de nieuwste technologieën.",
    features: [
      "Moderne technologie",
      "SEO geoptimaliseerd",
      "Veilig & betrouwbaar",
      "Schaalbaar"
    ]
  },
  {
    id: 3,
    title: "Website Onderhoud",
    description: "Continue ondersteuning, updates en technische hulp om je website altijd up-to-date te houden.",
    features: [
      "Regelmatige updates",
      "Technische support",
      "Aanpassingen",
      "Hosting & backup"
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Jan Vermeulen",
    company: "Fit & Strong Gym",
    text: "Thybe heeft een geweldige website voor onze sportschool gemaakt. Sinds de lancering hebben we 40% meer online aanmeldingen!",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah De Vries",
    company: "Crystal Clear Ramen",
    text: "Professioneel, snel en precies wat we nodig hadden. De website ziet er fantastisch uit en werkt perfect.",
    rating: 5
  },
  {
    id: 3,
    name: "Peter Janssens",
    company: "Business Boost Coaching",
    text: "Thybe denkt mee en levert kwaliteit. Onze nieuwe website straalt professionaliteit uit en trekt meer klanten aan.",
    rating: 5
  }
];

export const contactInfo = {
  name: "Thybe Ampe",
  email: "thybeampe@gmail.com",
  phone: "0493 97 33 43",
  address: "Beertegemstraat 42",
  vat: "BE1032.516.104",
  whatsapp: "32493973343"
};
